import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import { Core } from "@faire/design-tokens";
import { Column } from "@faire/web--source/slate/Layout";
import { HIGH_VIS_FILTER, highVisSlateComponent } from "@faire/web--source/slate/utils/highVisSlateComponent";
import styled from "styled-components";
var CenteredColumn = styled(Column).attrs({
  align: "center",
  justify: "center"
});
export var DropzoneContainer = CenteredColumn(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n  position: relative;\n  outline-offset: -8px;\n  outline: 1px dashed;\n  outline-color: ", ";\n  width: ", ";\n  height: ", ";\n  max-width: 100%;\n  background-color: ", ";\n  ", "\n"])), function (props) {
  return props.error ? Core.border.critical : Core.text.subdued;
}, function (props) {
  return props.width !== undefined ? "".concat(props.width, "px") : "100%";
}, function (props) {
  return props.height !== undefined ? "".concat(props.height, "px") : "200px";
}, Core.surface.subdued, highVisSlateComponent(HIGH_VIS_FILTER.COMPONENT));
export var MaxSizeDiv = styled.div.withConfig({
  displayName: "FileUploaderDropzonestyles__MaxSizeDiv"
})(["max-height:100%;max-width:100%;height:100%;width:100%;"]);
export var CentralContentWrapper = CenteredColumn(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 90%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: ", ";\n"])), function (props) {
  return props.color;
});